module.exports = __webpack_public_path__ + "static/media/card-clinica.17479fae.svg";